var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',{staticClass:"headline py-5"},[_vm._v("タグ一覧")]),_c('v-divider'),_c('tag-info-list',{attrs:{"tags":_vm.getBindTags}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }